"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAsThousands = exports.formatAsPercent = void 0;

var formatAsPercent = function formatAsPercent(val) {
  return val ? val.toFixed(1) + '%' : val;
};

exports.formatAsPercent = formatAsPercent;

var formatAsThousands = function formatAsThousands(val) {
  return Math.round(val / 1000).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + 'k';
};

exports.formatAsThousands = formatAsThousands;